import Wrapper from './wrapper.component'

export default Wrapper;